import { FC } from "react";
import "../../components/OrderTracking/styles.scss";
import OrderList from "../../components/OrderTracking";

const OrderTracking: FC = () => {
  return <OrderList />
};

export default OrderTracking;
